import { combineReducers } from '@reduxjs/toolkit'

import list from './listSlice'
import dashboard from './dashboardSlice'
import roles from './rolesSlice'
import users from './usersSlice'
import stores from './storesSlice'
import storeUsers from './storeUsersSlice'
import bankAccounts from './bankAccountsSlice'
import bankTransactions from './bankTransactionsSlice'
import walletTransactions from './walletTransactionsSlice'
import brands from './brandsSlice'
import categories from './categoriesSlice'
import attributes from './attributesSlice'
import expenses from './expensesSlice'
import customers from './customersSlice'
import vendors from './vendorsSlice'
import referrals from './referralsSlice'
import products from './productsSlice'
import purchases from './purchasesSlice'
import orders from './ordersSlice'
import storeOrders from './storeOrdersSlice'
import analysis from './analysis'

const reducer = combineReducers({
    list,
    dashboard,
    roles,
    users,
    stores,
    storeUsers,
    bankAccounts,
    bankTransactions,
    walletTransactions,
    brands,
    categories,
    attributes,
    expenses,
    customers,
    vendors,
    referrals,
    products,
    purchases,
    orders,
    storeOrders,
    analysis,
})

export default reducer
